import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge, ImageFileId } from './ot'

const BaseCardView1_2 = ({
    src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s",
    file_id = null,
}, ref) => {

    return (
        <div className="h-48 bg-gray-100 flex items-center justify-center">
            <div className="h-48 w-full  bg-white overflow-hidden flex items-center justify-center">
                <ImageFileId
                    className="w-full h-auto object-cover "
                    customize={true}
                    width="100%"
                    src={src}
                    file_id ={file_id}
                />
            </div>
        </div>
    )
}

export default BaseCardView1_2
